import { z } from 'zod';
import { ingredientUnitSchema, unitTypeSchema } from '../constants/units.js';
// ---------------------------------------------------------------------------
// Unit Conversion (reference table)
// ---------------------------------------------------------------------------
export const UnitConversionSchema = z.object({
    from_unit: ingredientUnitSchema,
    to_unit: ingredientUnitSchema,
    factor: z.number().positive(),
    unit_type: unitTypeSchema,
});
//# sourceMappingURL=unit-conversion.js.map